export default () => ({
  transactionEvents: [],
  eventsFetchInterval: null,
})
